<template>
  <div>
    <p> 
      <b v-if="yesNoMaybeSelection === 1"> {{ $t('resume.yourBuildingWillBeEquipedWithEnergyProductionUnit') }} </b>
      <b v-else-if="yesNoMaybeSelection === 0"> {{ $t('resume.yourBuildingWillNotBeEquipedWithEnergyProductionUnit') }} </b>
      <b v-else> {{ $t('resume.yourBuildingWillMaybeBeEquipedWithEnergyProductionUnit') }} </b>
    </p>
    <div v-if="yesNoMaybeSelection === 1 && kVA > 0 || kWC > 0">
      <span> <b> {{ $t('new-connection-cmh.energy-production-configuration-step.maximumPower') }} </b> </span>
        <br />
        <span v-if="kVA > 0"> {{ kVA }} kVA  </span>
        <br v-if="kVA > 0" />
        <span v-if="kWC > 0"> {{ kWC }} kWC  </span>
    </div>
  </div>
</template>

<script lang="ts">
import { YesNoMaybeSelection } from '@ores/vue-library'
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
  name: 'resume-energy-production'
})
export default class ResumeEnergyProduction extends Vue {
  @Prop({ type: Number, required: false, default: 0 }) public kVA!: number
  @Prop({ type: Number, required: false, default: 0 }) public kWC!: number
  @Prop({ type: Number, required: true }) public yesNoMaybeSelection!: YesNoMaybeSelection
}
</script>

<style scoped></style>
